import React, { useEffect, useMemo, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { checkIsMenuItemActive } from '../../../layouts/UserLayout/menus/helpers';

const useStyles = makeStyles((theme) => ({
  tabsRoot: {
    position: 'relative',
    minWidth: '100%',
    display: 'inline-block', // It helps me to make tabsProgress 100% width with scrollbar
    // https://stackoverflow.com/questions/33904792/cannot-make-div-width-100-with-scrollbar
  },
  tabsList: {
    display: 'flex',
    // every child(tab) with exception of the first tab
    '& > *:not(:first-child)': {
      marginLeft: '20px',
    },
  },
  tabsProgress: {
    marginTop: '10px',
    position: 'relative',
    backgroundColor: '#DAEFFB',
    borderRadius: '10px',
    height: '5px',
    width: '100%',
  },
  tabsProgress__current: {
    transition: '200ms',
    position: 'absolute',
    height: '5px',
    background: theme.palette.primary.main,
    borderRadius: '10px',
  },
  tab: {
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    color: 'black',
  },
}));

type PLinearTabs = {
  tabs: Array<{
    value: string | number;
    label: any;
  }>;
  value: any;
  onTabClick?: any;
  findCurrentTab?: (tabRefs: any) => any;
};

export const LinearTabs: React.FC<PLinearTabs> = (props) => {
  const classes = useStyles();
  const { value, tabs, onTabClick = () => {} } = props;
  const tabRefs = useRef([]);
  // Force rerender. I do it in order to run currentProgressStyles again;
  const [hardCode, setHardCode] = useState(1);

  useEffect(() => {
    setHardCode(2);
  }, []);

  const values = useMemo(() => {
    return tabs.map((tab) => tab.value);
  }, [tabs]);

  const currentProgressStyles = React.useMemo(() => {
    const currentElIndex = values.findIndex((item: any) =>
      String(value).includes(item),
    );
    const currentDomTab: any = tabRefs.current[currentElIndex];
    return {
      left: currentDomTab?.offsetLeft,
      width: currentDomTab?.offsetWidth,
    };
  }, [value, values, hardCode]);

  return (
    <div style={{ overflow: 'auto' }}>
      <div className={classes.tabsRoot}>
        <div className={classes.tabsList}>
          {tabs.map((tab) => {
            return (
              <div
                style={{ cursor: 'pointer' }}
                key={tab.value}
                // @ts-ignore
                ref={(ref) => tabRefs.current.push(ref)}
                onClick={() => onTabClick(tab.value)}
                className={classes.tab}
              >
                {tab.label}
              </div>
            );
          })}
        </div>

        <div className={classes.tabsProgress}>
          <span
            className={classes.tabsProgress__current}
            style={currentProgressStyles}
          />
        </div>
      </div>
    </div>
  );
};

type PLinearNavigationTabs = {
  tabs: Array<{
    value: string;
    label: any;
    locked?: boolean;
    [key: string]: any;
  }>;
  currentPath: any;
};

export const LinearNavigationTabs: React.FC<PLinearNavigationTabs> = (
  props,
) => {
  const classes = useStyles();
  const { tabs, currentPath } = props;
  const tabRefs = useRef([]);
  const [hardCode, setHardCode] = useState(1);
  useEffect(() => {
    setHardCode(2);
  }, []);

  const currentProgressStyles = React.useMemo(() => {
    const currentElIndex = tabs.findIndex((item) => {
      return checkIsMenuItemActive({
        currentPath,
        itemPath: item.path || item.value,
        basePath: item.basePath,
      });
    });

    const currentDomTab: any = tabRefs.current[currentElIndex];

    return {
      left: currentDomTab?.offsetLeft,
      width: currentDomTab?.offsetWidth,
    };
  }, [tabs, currentPath, hardCode]);

  return (
    <div style={{ overflow: 'auto' }}>
      <div className={classes.tabsRoot}>
        <div className={classes.tabsList}>
          {tabs.map((item) => {
            return item.locked ? (
              <div
                key={item.value}
                // @ts-ignore
                ref={(ref) => tabRefs.current.push(ref)}
                className={classes.tab}
              >
                {item.label}
              </div>
            ) : (
              <Link
                to={item.value}
                key={item.value}
                // @ts-ignore
                ref={(ref) => tabRefs.current.push(ref)}
                className={classes.tab}
              >
                {item.label}
              </Link>
            );
          })}
        </div>

        <div className={classes.tabsProgress}>
          <span
            className={classes.tabsProgress__current}
            style={currentProgressStyles}
          />
        </div>
      </div>
    </div>
  );
};
